import { gql } from '@apollo/client';
export const StatFeatureStaffHours = gql `
    fragment StatFeatureStaffHours on StaffHoursFeatureSettingsFlags {
        enabled
    }
`;
